import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { GetTeamMemberRatesOnProjectRequest } from '../types/dto/request/get-team-member-rates-on-project-request';
import { TeamMemberRatesOnProjectResponse } from '../types/dto/response/team-member-rates-on-project-response';

/**
 * Fetches team member rates on a specific project.
 * Returns all available rate options for the user and the project's rate configuration.
 *
 * Planner-owned endpoint: the backend gates it on the assignment policies and masks the rates
 * without PlannerFinancialsView. Another feature needing these rates gets its own backend route.
 *
 * @param params - Request parameters (teamMemberId, projectId, effectiveDate)
 * @returns Team member rates information
 */
export const getTeamMemberRatesOnProject = async (
  params: GetTeamMemberRatesOnProjectRequest
): Promise<TeamMemberRatesOnProjectResponse> => {
  const endpoint = '/api/assignments/rate-options';

  return await withApiErrorHandler(endpoint, ApiErrorCode.TEAM_MEMBERS_LOAD_FAILED, () =>
    axiosInstance.get<ApiResponse<TeamMemberRatesOnProjectResponse>>(endpoint, {
      params: {
        teamMemberId: params.teamMemberId,
        projectId: params.projectId,
        effectiveDate: params.effectiveDate,
      },
    })
  );
};
